// extracted by mini-css-extract-plugin
module.exports = {"PageWall":"PageWall_PageWall__3DgkI"};